import { SVGProps, Ref, forwardRef } from 'react';

export const BagPlusFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 .5c2.204 0 3.326 1.62 3.768 3.669 1.253.113 2.5.283 3.732.51l-.682 2.152.682 8.669H.5l.682-8.669L.5 4.68a41 41 0 0 1 3.731-.51C4.673 2.119 5.796.5 8 .5m-.7 8.55H5v1.4h2.3v2.3h1.4v-2.3H11v-1.4H8.7v-2.3H7.3zM8 1.9c-.918 0-1.486.406-1.901 1.155a4.7 4.7 0 0 0-.402 1.01 42 42 0 0 1 4.605 0 4.7 4.7 0 0 0-.4-1.01C9.485 2.306 8.917 1.9 8 1.9"
                fill="currentColor"
            />
        </g>
    </svg>
));
BagPlusFilledSize16Glyph.displayName = 'BagPlusFilledSize16Glyph';
